var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssessmentScore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 77,
    viewBox: "0 0 76 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.164062,
    width: 76,
    height: 76,
    rx: 38,
    fill: "#DF9B21",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M37.9999 45.4987C27.44 45.4987 25.5693 34.9745 25.2379 26.6272C25.1457 24.3053 25.0996 23.1444 25.9718 22.0702C26.8439 20.9961 27.8877 20.82 29.9754 20.4677C32.0362 20.12 34.73 19.832 37.9999 19.832C41.2697 19.832 43.9635 20.12 46.0243 20.4677C48.112 20.82 49.1558 20.9961 50.028 22.0702C50.9001 23.1444 50.854 24.3053 50.7619 26.6272C50.4305 34.9745 48.5598 45.4987 37.9999 45.4987Z",
    fill: "#DD9D2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.341 38.9391L53.5046 36.0703C54.8841 35.3039 55.5738 34.9207 55.9536 34.2752C56.3335 33.6297 56.3335 32.8406 56.3336 31.2626L56.3336 31.1297C56.3336 29.2164 56.3336 28.2597 55.8145 27.5395C55.2955 26.8193 54.3879 26.5168 52.5728 25.9117L50.8337 25.332L50.8026 25.4872C50.7941 25.8342 50.7791 26.2121 50.7626 26.6272C50.6007 30.7052 50.0714 35.3029 48.341 38.9391Z",
    fill: "#DD9D2A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2386 26.6272C25.4005 30.7055 25.9299 35.3033 27.6605 38.9396L22.4959 36.0703C21.1165 35.3039 20.4268 34.9207 20.0469 34.2752C19.6671 33.6297 19.667 32.8406 19.667 31.2626L19.667 31.1297C19.6669 29.2164 19.6669 28.2597 20.186 27.5395C20.7051 26.8193 21.6126 26.5168 23.4277 25.9117L25.1669 25.332L25.1987 25.491C25.2072 25.837 25.2222 26.2137 25.2386 26.6272Z",
    fill: "#DD9D2A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.625 56.4961C25.625 55.7367 26.2406 55.1211 27 55.1211H49C49.7594 55.1211 50.375 55.7367 50.375 56.4961C50.375 57.2555 49.7594 57.8711 49 57.8711H27C26.2406 57.8711 25.625 57.2555 25.625 56.4961Z",
    fill: "#DD9D2A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M44.339 55.1232H31.6611L32.2053 51.9152C32.3767 51.0582 33.1291 50.4414 34.003 50.4414H41.9971C42.871 50.4414 43.6234 51.0582 43.7948 51.9152L44.339 55.1232Z",
    fill: "#DD9D2A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0003 45.4965C37.5244 45.4965 37.0662 45.4752 36.625 45.4336V50.4395H39.375V45.4336C38.934 45.4752 38.4759 45.4965 38.0003 45.4965Z",
    fill: "#DD9D2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentScore);
export default __webpack_public_path__ + "static/media/assessment_score.93cda1be2225103bc9dda9c453caa0ed.svg";
export { ForwardRef as ReactComponent };